/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Shadow_OnInputs */

const fr_label_shadow_on = /** @type {(inputs: Label_Shadow_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activée`)
};

const en_label_shadow_on = /** @type {(inputs: Label_Shadow_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Label_Shadow_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_shadow_on = /** @type {((inputs?: Label_Shadow_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Shadow_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_shadow_on(inputs)
	return en_label_shadow_on(inputs)
});